export const playList = [
    {
    writer: "Вседхармыпусты — Мечта",
    name: "аранжировка, сонграйтинг, сведение и мастеринг",
    img:
      "mechta.jpg",
    src: "1.mp3",

    id: 1
  },
  {
    writer: "oliuminarium — Somewhere",
    name: "аранжировка, сведение и мастеринг",
    img:
      "somewhere.jpg",
    src: "2.mp3",

    id: 2
  },
  {
   writer: "СТАС КРЮКОВ — Цунами",
    name: "аранжировка, сонграйтинг, сведение и мастеринг",
    img:
      "zunami.jpg",
    src: "10.mp3",

    id: 3
  },
  {
    writer: "durrra — Снова",
    name: "аранжировка, сведение и мастеринг",
    img: "luv.jpeg",
    src: "3.mp3",

    id: 4
  },
    {
    writer: "oliuminarium — Все плохое",
    name: "аранжировка, сведение и мастеринг",
    img: "plohoe.jpg",
    src: "4.mp3",

    id: 5
  },
    {
    writer: "oliuminarium — Камасутра",
    name: "аранжировка, сведение и мастеринг",
    img: "kama.jpg",
    src: "5.mp3",

    id: 6
  },
    {
    writer: "durrra — Время-вода",
    name: "аранжировка, сведение и мастеринг",
    img: "luv.jpeg",
    src: "6.mp3",

    id: 7
  },
      {
    writer: "СТАС КРЮКОВ — Мгновение",
    name: "аранжировка, сонграйтинг, мастеринг",
    img: "dengy.jpg",
    src: "7.mp3",

    id: 8
  },

      {
    writer: "durrra — Играй",
    name: "аранжировка, сведение и мастеринг",
    img: "luv.jpeg",
    src: "8.mp3",

    id: 9
  },

      {
    writer: "СТАС КРЮКОВ — Забытье",
    name: "аранжировка, сонграйтинг, мастеринг",
    img: "zabytie.jpg",
    src: "9.mp3",

    id: 10
  }
];
